import { Tag, TagVariant } from '@deliveryhero/pd-cookbook/components/Tag';

import { User, UserRoles, UserStates } from 'services/api';
import { Column } from 'src/components/TableList/SortableHeader';

const renderTag = (variant: TagVariant, label: string) => {
  return <Tag id={variant} label={label} variant={variant} />;
};

export const EmployeeListingColumns: Column<
  User & { departmentName: string }
>[] = [
  {
    id: 'name',
    label: 'Name'
  },
  {
    id: 'departmentName',
    label: 'Department'
  },
  {
    id: 'state',
    label: 'Account Status',
    format: (employee) => {
      return employee.state === UserStates.Active
        ? renderTag(TagVariant.SUCCESS, 'Active')
        : employee.state === UserStates.Invited
        ? renderTag(TagVariant.POPULAR, 'Invited')
        : employee.state === UserStates.Suspended
        ? renderTag(TagVariant.INFORMATION, 'Suspended')
        : renderTag(TagVariant.INACTIVE, 'Deleted');
    }
  },
  {
    id: 'role',
    label: 'Role',
    format: (employee) =>
      employee.role === UserRoles.User ? 'User' : 'Manager'
  }
];
